var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaySquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.0625 19.6875H20.4375V4.3125H5.0625V19.6875ZM10.6875 8.32734C10.6875 8.10703 10.943 7.98281 11.1164 8.12109L15.7898 11.7938C15.821 11.8183 15.8463 11.8496 15.8636 11.8854C15.881 11.9211 15.89 11.9603 15.89 12C15.89 12.0397 15.881 12.0789 15.8636 12.1146C15.8463 12.1504 15.821 12.1817 15.7898 12.2062L11.1164 15.8812C10.943 16.0172 10.6875 15.8953 10.6875 15.675V8.32734Z",
    fill: "white",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.375 2.625H4.125C3.71016 2.625 3.375 2.96016 3.375 3.375V20.625C3.375 21.0398 3.71016 21.375 4.125 21.375H21.375C21.7898 21.375 22.125 21.0398 22.125 20.625V3.375C22.125 2.96016 21.7898 2.625 21.375 2.625ZM20.4375 19.6875H5.0625V4.3125H20.4375V19.6875Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1164 15.8813L15.7898 12.2063C15.821 12.1817 15.8463 12.1504 15.8636 12.1146C15.881 12.0789 15.89 12.0397 15.89 12C15.89 11.9603 15.881 11.9211 15.8636 11.8854C15.8463 11.8497 15.821 11.8183 15.7898 11.7938L11.1164 8.12109C10.943 7.98281 10.6875 8.10703 10.6875 8.32734V15.675C10.6875 15.8953 10.943 16.0172 11.1164 15.8813Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaySquare);
export default __webpack_public_path__ + "static/media/play-square.a9932de86285d7f5e9f94e050b16eba5.svg";
export { ForwardRef as ReactComponent };